import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import { Row, Col, Spin } from "antd";
import { isEmpty } from "lodash";
import moment from "moment";
// SHARED
import ModuleTitleBar from "Components/shared/module-title-bar/module-title-bar";
import { DataListType } from "Types/common.types";
import { DetailsContainer } from "Components/shared/details-container";

//SCSS
import "./dispatch-details.scss";
import AssignDriverBulkLooseModal from "Components/delivery-management/parcel-tracking-modals/assign-driver-bulk-loose-modal/assign-driver-bulk-loose";
import { BasicModal, Button } from "@life-line-lab/components-react";
import { LoadingOutlined } from "@ant-design/icons";

const DispatchInformation = ({ orderDetails, dispatchDetails, isPickup }) => {
  const { t } = useTranslation();

  const pickupDetails = {
    typeOfLocation: isPickup ? "pickupLocation" : "dropOffLocation",
    typeOfTime: isPickup ? "pickupTiming" : "dropoffDateEta",
    categoryOfDriver: isPickup ? "pickedUpBy" : "noOfDriverExpected",
    fullAddress: isPickup ? dispatchDetails?.pickupLocation : dispatchDetails?.dropOffLocation,
    fullTime: {
      timeFrom: isPickup ? dispatchDetails?.pickupTimeFrom : dispatchDetails?.dropOffTimeFrom,
      timeTo: isPickup ? dispatchDetails?.pickupTimeTo : dispatchDetails?.dropOffTimeTo,
    },
    driverCategory: isPickup
      ? orderDetails?.assignedDriverData?.fullName
      : dispatchDetails?.noOfDrivers ?? "-",
    pickedupAt: isPickup ? dispatchDetails?.pickedupAt ?? "-" : null,
    typeOfDriver: isPickup
      ? orderDetails?.assignedDriver === "THIRD_PARTY"
        ? "Third Party"
        : "Diolko"
      : null,
    driverName: isPickup ? orderDetails?.assignedDriverData?.fullName : null,
    vehicleType: isPickup
      ? orderDetails?.assignedDriverData?.vehicleData?.vehicleType ?? null
      : null,
    vehicleWeightCapacity: isPickup
      ? orderDetails?.assignedDriverData?.vehicleData?.maxWeight
        ? orderDetails?.assignedDriverData?.vehicleData?.maxWeight + " kg"
        : "-"
      : "-",
    vehicleNo: isPickup
      ? orderDetails?.assignedDriverData?.vehicleData?.registrationNo ?? "-"
      : "-",
  };

  const RowOne = () => {
    return (
      <>
        <Col span={24}>
          <Row gutter={[0, 8]}>
            <Col span={24}>
              <label className="title"> {t("label.trackingNo")} </label>
            </Col>
            <Col span={24}>
              {!isEmpty(orderDetails?.childrenOrdersData) ? (
                orderDetails.childrenOrdersData.map((order) => (
                  <div>{`${order.trackingNumber}/${order.runningNumber}`}</div>
                ))
              ) : (
                <div>{orderDetails?.trackingNumber}</div>
              )}
            </Col>
          </Row>
        </Col>
      </>
    );
  };

  const RowTwo = () => {
    return (
      <>
        <Col span={12}>
          <Row gutter={[0, 8]}>
            <Col span={24}>
              <label className="title">{t(`label.${pickupDetails.typeOfLocation}`)}</label>
            </Col>
            <Col span={24}>
              {pickupDetails?.fullAddress?.street1 ? (
                <>
                  <div>
                    {pickupDetails?.fullAddress?.street1} {pickupDetails?.fullAddress?.street2},
                  </div>
                  <div>
                    {pickupDetails?.fullAddress?.postcode} {pickupDetails?.fullAddress?.city},
                  </div>
                  <div>
                    {pickupDetails?.fullAddress?.state} {pickupDetails?.fullAddress?.country}
                  </div>
                </>
              ) : (
                t("label.unavailable")
              )}
            </Col>
          </Row>
        </Col>
        <Col span={12}>
          <Row gutter={[0, 8]}>
            <Col span={24}>
              <label className="title">{t(`label.${pickupDetails.typeOfTime}`)}</label>
            </Col>
            <Col span={24}>
              {pickupDetails?.fullTime?.timeFrom || pickupDetails?.fullTime?.timeTo ? (
                <>
                  {moment(pickupDetails?.fullTime?.timeFrom).format("hh:mm a")} -{" "}
                  {moment(pickupDetails?.fullTime?.timeTo).format("hh:mm a")}
                </>
              ) : (
                t("label.unavailable")
              )}
            </Col>
          </Row>
        </Col>
      </>
    );
  };

  const RowThree = () => {
    return (
      <>
        <Col span={12}>
          <Row gutter={[0, 8]}>
            <Col span={24}>
              <label className="title">{t(`label.${pickupDetails?.categoryOfDriver}`)}</label>
            </Col>
            <Col span={24}>{pickupDetails?.driverCategory}</Col>
          </Row>
        </Col>
        <Col span={12}>
          <Row gutter={[0, 8]}>
            <Col span={24}>
              <label className="title">{isPickup && t("label.droppedOffAt")}</label>
            </Col>
            <Col span={24}>{pickupDetails?.pickedupAt}</Col>
          </Row>
        </Col>
        <Col span={12}>
          <Row gutter={[0, 8]}>
            <Col span={24}>
              <label className="title">{t("label.driverAssigned")}</label>
            </Col>
            <Col span={24}>
              {pickupDetails?.driverName ? (
                <>
                  {pickupDetails?.driverName} ({pickupDetails?.typeOfDriver})
                </>
              ) : (
                "-"
              )}
            </Col>
          </Row>
        </Col>
        <Col span={12}>
          <Row gutter={[0, 8]}>
            <Col span={24}>
              <label className="title">{t("label.vehicleAssigned")}</label>
            </Col>{" "}
            <Col span={24}>
              {pickupDetails?.vehicleType ? (
                <>
                  {pickupDetails?.vehicleNo} ({pickupDetails?.vehicleType},
                  {pickupDetails?.vehicleWeightCapacity})
                </>
              ) : (
                "-"
              )}
            </Col>
          </Row>
        </Col>
      </>
    );
  };

  return (
    <div>
      <Row gutter={[16, 24]}>
        <RowOne />
        {dispatchDetails && (
          <>
            <RowTwo />
            <RowThree />
          </>
        )}
      </Row>
    </div>
  );
};

const modalPackages = () => {
  const initialModal: any = {
    open: false,
  };

  const [callModal, setCallModal] = useState<any>(<></>);
  const [modal, setModal] = useState<any>(initialModal);

  const handleResetModalState = () => {
    setModal(initialModal);
  };

  return {
    callModal,
    setCallModal,
    modal,
    setModal,
    handleResetModalState,
  };
};

const DispatchDetails = ({
  orderDetails,
  orderDispatchDetails,
  isLoading,
  vehicleOptions,
  sortingHubOptions,
  handleAssignDriver,
}) => {
  const dispatchDetails = orderDispatchDetails.orderDispatch;
  const { t } = useTranslation();

  const { modal, callModal, setModal, setCallModal, handleResetModalState } = modalPackages();

  const findPickupDropOff = () => {
    switch (orderDetails.deliveryTypeName) {
      case "End To End":
      case "First-Mile":
        return true;
      default:
        return false;
    }
  };

  const isPickup = findPickupDropOff();

  // assign driver button only enables when the status is in returned
  const isInReview = orderDetails?.orderStatusInfo?.orderStatus == "RETURNED";

  const handleOpenAssignBulkDriverModal = () => {
    setCallModal(
      <AssignDriverBulkLooseModal
        selectedOrder={orderDetails._id}
        selectedOrderDetails={orderDetails}
        vehicleOptions={vehicleOptions}
        sortingHubOptions={sortingHubOptions}
        onSubmit={(value) => {
          handleAssignDriver(value);
          handleResetModalState();
        }}
        type={"ASSIGN"}
        handleCancel={handleResetModalState}
        enableHandover={true}
      />,
    );
    setModal({ open: true });
  };

  return (
    <div className="order-details">
      {isLoading ? (
        <div className="loading-container">
          <Spin size="large" indicator={<LoadingOutlined />} />
        </div>
      ) : (
        <>
          <div className="dm-put-content">
            <Row>
              <Col span={20}>
                <DispatchInformation
                  orderDetails={orderDetails}
                  dispatchDetails={dispatchDetails}
                  isPickup={isPickup}
                />
              </Col>
              <Col span={4} style={{ display: "flex", justifyContent: "flex-end" }}>
                {isInReview && (
                  <Button
                    type="default"
                    label={t("action.assignDriver")}
                    size="large"
                    onClick={() => {
                      handleOpenAssignBulkDriverModal();
                    }}
                  />
                )}
              </Col>
            </Row>
          </div>
          <BasicModal
            className="modal"
            isOpen={modal.open}
            isClosable={true}
            isMaskClosable={false}
            onClose={() => {
              handleResetModalState();
            }}
          >
            {callModal}
          </BasicModal>
        </>
      )}
    </div>
  );
};

export default DispatchDetails;
